<template>
  <div class="select-response-create" >
    <component
      :is="selectComponent"
      :model="model"
      :disabled="disabled"
      :clearable="clearable"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template v-if="isVisibleIcon" v-slot:prefix>
        <i class="el-icon-plus" tabindex="0" @click.capture.stop="handlerCreate"></i>
      </template>
    </component>
    <el-dialog
      :visible.sync="isOpenCreateDialog"
      append-to-body
      :title="title"
      @close="close"
    >
      <template v-slot:default>
        <div v-loading="isLoading">
          <slot name="form" :change="handlerChange" :data="data"></slot>
          <div class="select-response-create__footer">
            <slot name="footer" :command="commandController">
              <button
                type="button"
                class="btn btn-border grey btn-size-s btn-mobile-full select-response-create__btn"
                @click="commandController('cancel')"
              >
                {{L10n('cancel')}}
              </button>
              <button
                type="button"
                class="btn btn-size-s btn-mobile-full select-response-create__btn"
                @click="commandController('create')"
              >
                {{L10n('create')}}
              </button>
            </slot>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { api } from '@/services/api'
export default {
  name: 'SelectResponseCreate',
  inheritAttrs: false,
  props: {
    model: { required: true },
    canCreate: { type: Boolean, default: true },
    createRequest: { type: Function }, // Must return a Promise
    disabled: { type: Boolean, default: false },
    createTitle: { type: String, default: '' },
    createApi: { type: String, required: true },
    createModel: { type: Function, required: true },
    clearable: { type: Boolean, default: false }
  },
  data () {
    return {
      isOpenCreateDialog: false,
      isLoading: false,
      data: {}, // For updating form
      formData: {} // data of form
    }
  },
  computed: {
    title () {
      return this.createTitle || this.L10n('create')
    },
    isVisibleIcon () {
      return this.canCreate && !this.disabled
    },
    selectComponent () {
      if (this.$attrs.api) {
        return 'SelectResponseAutoComplete'
      } else {
        return 'SelectResponse'
      }
    }
  },
  methods: {
    commandController (command) {
      if (command === 'cancel') {
        return this.close()
      }
      if (command === 'create') {
        return this.create()
      }
      console.error(`SelectCreate => Unknown command "${command}"`)
    },
    handlerCreate () {
      if (!this.disabled && this.canCreate) {
        this.show()
      }
    },
    handlerChange (data) {
      this.formData = { ...data }
    },
    reset () {
      this.data = {}
      this.formData = {}
    },
    show () {
      this.isOpenCreateDialog = true
      this.reset()
    },
    close () {
      this.isOpenCreateDialog = false
      this.reset()
    },
    create () {
      this.$emit('validate', (result) => {
        if (result instanceof Error) {
          console.warn('validate error')
        } else {
          this.request()
        }
      })
    },
    request () {
      this.isLoading = true
      const requestMethod = this.createRequest || this._createRequest
      return requestMethod(this.formData)
        .then(data => {
          this.requestSuccessHandler()
          this.$emit('update:model', data.id)
          this.close()
          this.$emit('on-created', data)
        })
        .catch(err => {
          this.requestErrorHandler(err)
        })
        .then(() => {
          this.isLoading = false
        })
    },
    _createRequest (data) {
      return api
        .post(`${this.createApi}`, data)
        .then((response) => {
          return response.data
        })
    }
  }
}
</script>
<style lang="stylus">
  .select-response-create{
    .el-input__inner{
      padding-right 3.5rem !important
    }
    .el-input__prefix {
      z-index 10
      color #36587a
      left unset
      right 0
      cursor pointer
    }
    .el-input__suffix{
      right 1.5rem !important
    }
  }
  .select-response-create__footer{
    padding-top 1.5rem
    display flex
    justify-content flex-end
    align-items center
  }
  .select-response-create__btn{
    margin-left 1rem
  }
  @media only screen and (max-width: 576px) {
    .select-response-create__btn {
      margin .5rem 0
    }
  }
</style>
